import { Fragment, MouseEvent, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LogoutIcon from '@mui/icons-material/Logout';
import PolicyIcon from '@mui/icons-material/Policy';
import { Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Popover, Typography } from '@mui/material';

import { PRIVACY_POLICY } from '@/dmdrive/core/constants/urls';
import { useStore } from '@/dmdrive/store';
import UserAvatar from '@/dmdrive/user/components/UserAvatar/UserAvatar';

import { UserAccountInfo, UserEmail, UserMenuIcon, UserMenuRoot, UserName } from './UserMenu.styles';

function UserMenu() {
  const { user, logout } = useStore('appStore');
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLDivElement>>(null);

  const onOpenMenu = useCallback((event: MouseEvent<HTMLDivElement>) => setAnchorEl(event.currentTarget), []);

  const onCloseMenu = useCallback(() => setAnchorEl(null), []);

  const onClickPrivacyPolicy = useCallback(() => {
    onCloseMenu();
    window.open(PRIVACY_POLICY, '_blank');
  }, []);
  const onLogoutHandler = useCallback(() => {
    onCloseMenu();
    logout();
  }, []);

  if (!user) {
    return null;
  }

  const isOpen = Boolean(anchorEl);

  return (
    <Fragment>
      <UserMenuRoot isOpened={isOpen} onClick={onOpenMenu}>
        <UserAvatar size="sm" username={user.username} />

        <UserName>{user.name}</UserName>

        <UserMenuIcon isOpened={isOpen}>
          <ArrowDropDownIcon />
        </UserMenuIcon>
      </UserMenuRoot>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onCloseMenu}
        elevation={8}
        anchorOrigin={{
          vertical: (anchorEl?.offsetHeight ?? 0) + 5 /* offset from top */,
          horizontal: 'left',
        }}
      >
        <UserAccountInfo>
          <Typography variant="body1">{user.username}</Typography>

          <UserEmail variant="body2">{user.email}</UserEmail>
        </UserAccountInfo>

        <Divider />

        <MenuList>
          <MenuItem onClick={onClickPrivacyPolicy}>
            <ListItemIcon>
              <PolicyIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>Privacy Policy</ListItemText>
          </MenuItem>

          <Divider />

          <MenuItem onClick={onLogoutHandler}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>Sign Out</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </Fragment>
  );
}

export default observer(UserMenu);
